import { render, staticRenderFns } from "./UserSkillsInventorySection.vue?vue&type=template&id=41455a53&"
import script from "./UserSkillsInventorySection.vue?vue&type=script&lang=js&"
export * from "./UserSkillsInventorySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardSection: require('/workspace/components/Dashboard/DashboardSection.vue').default})
